import React, { Fragment, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { mapOperations } from '../redux/map';
import { authOperations } from '../redux/auth';
import { filterOperations } from '../redux/filter';
import { configOperations } from '../redux/config';
import { incidentsOperations } from '../redux/incidentList';

import IconButton from '@mui/material/IconButton'
import Avatar from 'material-ui/Avatar';
import FlatButton from 'material-ui/FlatButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import DropdownIcon from 'material-ui/svg-icons/navigation/arrow-drop-down';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import ContactsIcon from '@mui/icons-material/Contacts';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import Link from '@mui/material/Link';
import Divider from '@material-ui/core/Divider';
import InsertChartIcon from '@material-ui/icons/InsertChart';
import SignoutIcon from 'material-ui/svg-icons/action/power-settings-new';
import FeedbackIcon from 'material-ui/svg-icons/action/feedback';
import AssignmentIcon from 'material-ui/svg-icons/action/assignment';
import ReportIcon from 'material-ui/svg-icons/content/report';
import Badge from '@mui/material/Badge';
import Typography from '@material-ui/core/Typography';
import NewIncidentDialog from './newIncident/NewIncidentDialog';
import GeneralReportingDialog from './reporting/GeneralReportingDialog';
import DataDictionaryPanel from './dictionary/DataDictionaryPanel';
import AdminPanel from './admin/AdminPanel';
import AppMetricsPanel from './admin/AppMetricsPanel';
//import NotificationsDialog from './notifications/NotificationsDialog';
import IncidentLookupDialog from './incidentLookup/IncidentLookupDialog';
import theme from '../muiTheme';

class Header extends Component {

  constructor(props) {
    super(props);

    this.state = {
      userMenuOpen: false,
      dataDictionaryOpen: false,
      changeLogOpen: false,
      knownIssuesOpen: false,
      showingNewIncidentDialog: false,
      showingReportingDialog: false,
      adminPanelOpen: false,
      userNotificationsOpen: false,
      metricsPanelOpen: false,
      appMetricsPackage: null,
      incidentLookupOpen: false
    };
  }

  //avatarClick
  avatarClick = (event) => {
    event.preventDefault();

    //this.setState({
    //  userNotificationsOpen: true
    //});
  };

  userMenuClick = (event) => {
    event.preventDefault();

    this.setState({
      userMenuOpen: true,
      anchorEl: event.currentTarget,
    });
  };

  openAdminPanel = (event) => {
    event.preventDefault();

    this.setState({
      userMenuOpen: false,
      adminPanelOpen: true,
    });
}

openUserNotifications = (event) => {
  event.preventDefault();

  this.setState({
    userMenuOpen: false,
    userNotificationsOpen: true,
  });
}

openIncidentLookup = (event) => {
  event.preventDefault();

  this.setState({
    incidentLookupOpen: true,
    userMenuOpen: false
  });
}

incidentLookupClose = () => {

  this.setState({
    incidentLookupOpen: false
  });
}

openAppMetricsPanel = (event) => {
  event.preventDefault();

  this.setState({
    userMenuOpen: false,
    metricsPanelOpen: true,
  });

  window.api.getAppMetrics().then(response => 
    {
      this.setState({
        appMetricsPackage: response
      });
    });
}
  openDataDictionary = (event) => {
      event.preventDefault();
      //history.push("/dictionary");

      this.setState({
        userMenuOpen: false,
        dataDictionaryOpen: true,
      });

  }

  closeChangeLog = () =>
    {
      this.setState({
        changeLogOpen: false
      });
    }

  closeKnownIssues = () =>
    {
      this.setState({
        knownIssuesOpen: false
      });
    }

  openChangeLog = (event) => {
      event.preventDefault();

      this.setState({
        userMenuOpen: false,
        changeLogOpen: true,
      });
    }

  openKnownIssues = (event) => {
      event.preventDefault();

      this.setState({
        userMenuOpen: false,
        knownIssuesOpen: true,
      });
    }

  loadReporting = (event) =>
  {
    event.preventDefault();

    this.setState({
      userMenuOpen: false,
      showingReportingDialog: true
    });

  };

  reportNewIncident = (event) =>
  {
    event.preventDefault();

    this.setState({
      userMenuOpen: false,
      showingNewIncidentDialog: true
    });

  };

 generalReportingClose = () =>
 {
   this.setState({
     showingReportingDialog: false
   });
 }

 adminPanelClose = () =>
 {
   this.setState({
     adminPanelOpen: false
   });
 }

 notificationsDialogClose = () =>
  {
    this.setState({
      userNotificationsOpen: false
    });
  }

 metricsPanelClose = () =>
 {
   this.setState({
    metricsPanelOpen: false
   });
 }

  dataDictionaryClose = () =>
    {
      this.setState({
        dataDictionaryOpen: false
      });
    }

    onCloseAddIrwinIdToPerimeter = () => {
      this.props.setAddIrwinIdToPerimeter(null);
    }

  newIncidentClose = () =>
  {
    this.setState({
      showingNewIncidentDialog: false
    });

  };

  handleAddNewIncident = () =>
  {
    this.setState({
      showingNewIncidentDialog: false
    });

  };

  userMenuClose = () => {
    this.setState({
      userMenuOpen: false,
    });
  };

  render() {
    let userAvatar;
    let environmentLabel = (this.props.appConfig.env !== 'prod')
    ? (<h2 style={{display: "inline", marginLeft:"110px"}}>TESTING - {this.props.appConfig.env.toUpperCase()} - {this.props.appConfig.appVersion + "." + this.props.appConfig.minorReleaseVersion} </h2>)
    : (<h5 style={{display: "inline", marginLeft:"40px"}}>v{this.props.appConfig.appVersion + "." + this.props.appConfig.minorReleaseVersion}</h5>);

    let trainingLink = (this.props.appConfig.env === 'prod') ? (
      <Fragment>
        <Link href='https://informoat.firenet.gov/inspector-next' target="_blank">Inspector - Training Version (OAT-NEXT)</Link><br/>
      </Fragment>
    ) : ('');

    if (this.props.auth.user.thumbnailUrl) {
      userAvatar = (
        <Avatar
          src={this.props.auth.user.thumbnailUrl}
          style={{marginRight: "5px", border: "1px solid #fff"}}
          size={30} />
      )
    } else {
      userAvatar = (
        <IconButton color="inherit" onClick={this.avatarClick} style={{ position: "relative", float: "right", marginLeft: "auto" }} aria-label="close">      
            <Avatar
            style={{marginRight: "5px"}}
            color={theme.palette.accent1Color}
            backgroundColor={theme.palette.canvasColor}
            size={30} >
            {this.props.auth.user.fullName[0]}
          </Avatar>
        </IconButton>
      )
    }
      return (
        <div className={`app-header${(this.props.appConfig.env !== 'prod') ? "-red" : ""}`}>
          <div className="header-branding">
            <h1 style={{display: "inline"}}>INSPECTOR</h1>
            {environmentLabel}
          </div>
          <div className="header-user">
            {userAvatar}
            <FlatButton
              onClick={this.userMenuClick}
              label={this.props.auth.user.fullName}
              labelPosition="before"
              labelStyle={{color: "#fff", paddingLeft: "10px"}}
              hoverColor={theme.palette.accent3Color}
              icon={<DropdownIcon color="#fff" style={{marginRight: "5px"}} />}/>
            <Popover
              open={this.state.userMenuOpen}
              anchorEl={this.state.anchorEl}
              anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
              targetOrigin={{horizontal: 'right', vertical: 'top'}}
              onRequestClose={this.userMenuClose} >
              <Menu>
                {this.props.auth.isAdmin &&
                  <MenuItem
                  onClick={this.openAdminPanel}
                  leftIcon={<AdminPanelSettingsIcon color="#FF0000" />} primaryText="Admin" />
                }
                 {this.props.auth.isAdmin &&
                  <MenuItem
                  onClick={this.openAppMetricsPanel}
                  leftIcon={<EqualizerIcon color="#FF0000" />} primaryText="App Metrics" />
                }
                <MenuItem
                  onClick={this.openIncidentLookup}
                  leftIcon={<FindInPageIcon color="#6fa8dc" />} primaryText="Incident Lookup" />

                <MenuItem
                  onClick={this.reportNewIncident}
                  disabled={this.props.auth.isReadOnly}
                  leftIcon={<ReportIcon color="#FF0000" />} primaryText="Report a new Incident" />
                <MenuItem
                  href='https://nifc.maps.arcgis.com/sharing/rest/content/items/ae3b0bd513b6479d90f4a54466e28399/data' target="_new"
                  leftIcon={<AssignmentIcon />} primaryText="Data Dictionary" />
                  <MenuItem
                    onClick={this.loadReporting}
                    leftIcon={<InsertChartIcon color="primary"/>} primaryText="Reports" />
                <MenuItem
                  onClick={this.props.logout}
                  leftIcon={<SignoutIcon />} primaryText="Sign out" />
                  <MenuItem
                    href='https://in-form-nifc.hub.arcgis.com/pages/in-form-contacts' target="_new"
                    leftIcon={<ContactsIcon />} primaryText="Contacts" />
                <MenuItem
                  href='mailto:InFORM@FireNet.gov' target="_blank"
                  leftIcon={<FeedbackIcon />} primaryText="Feedback" />

              </Menu>
              <Divider />
              <Typography  style={{marginLeft: "10px"}} component="h6">
              Links
              </Typography>
              <div style={{marginLeft: "25px"}}>
                {trainingLink}
                <Link href='https://in-form-nifc.hub.arcgis.com/pages/in-form-known-bugs' target="_blank">Known bugs</Link><br/>
                <Link href='https://irwin.doi.gov/observer/' target="_blank">Irwin Observer</Link><br/>
                <Link href='https://in-form-nifc.hub.arcgis.com/pages/in-form-tips' target="_blank">InFORM Training Materials</Link><br/>
                <Link href='https://nifc.maps.arcgis.com/sharing/rest/content/items/fcf4bd45b36f470988d48991fa2f4ade/data' target="_blank">InFORM User Guide and Data Dictionary</Link><br/>
                <Link href='http://wildfire.gov' target="_blank">FAMAuth Portal (EGP, SIT209, etc)</Link><br/>
                <Link href='https://nifc.maps.arcgis.com/home/index.html' target="_blank">NIFC AGOL</Link><br/>
                <Link href='https://unitid.nifc.gov/ords/prd/f?p=116:101:8506784531427:::RP::' target="_blank">WFMI Unit ID Module</Link><br/>
                <Link href='https://www.nwcg.gov/' target="_blank">NWCG</Link><br/>
                <Link href='https://www.fs.usda.gov/rm/pubs_series/rmrs/gtr/rmrs_gtr153.pdf' target="_blank">Fire Behavior Fuel Models</Link><br/>
              </div>
            </Popover>
          </div>

          <NewIncidentDialog
            open={this.state.showingNewIncidentDialog}
            onNewIncidentClose={this.newIncidentClose}
            />
            <IncidentLookupDialog
             open={this.state.incidentLookupOpen}
             onClose={this.incidentLookupClose}
            />
            <GeneralReportingDialog
              open={this.state.showingReportingDialog}
              onClose={this.generalReportingClose}
              />
            <DataDictionaryPanel
              open={this.state.dataDictionaryOpen}
              onClose={this.dataDictionaryClose}
              />
            <AdminPanel
              open={this.state.adminPanelOpen}
              onClose={this.adminPanelClose}/> 

          <AppMetricsPanel
              open={this.state.metricsPanelOpen}
              appMetricsPackage={this.state.appMetricsPackage}
              onClose={this.metricsPanelClose} />
        </div>
      )
    }
  }

  const mapStateToProps = state => ({
    map: state.map,
    auth: state.auth,
    appConfig: state.config,
    filter: state.filter,
    incidentList: state.incidentList
  })

  const mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
      ...mapOperations,
      ...authOperations,
      ...filterOperations,
      ...configOperations,
      ...incidentsOperations
    }, dispatch);
  }

  export default connect(mapStateToProps, mapDispatchToProps)(Header)
